<div class="replay-progress-bar">
  @for (fill of fillLevels(); track $index) {
    <div class="progress-segment">
      <div class="segment-fill" [style.width.%]="fill"></div>
    </div>
  }
</div>
